// src/components/Main.js
import React from "react";
import Hero from "../components/main/hero.jsx";
import AboutUs from "../components/main/aboutUs.jsx";
import Entreprise from "../components/main/entreprise.jsx";
import Formation from "../components/main/formation.jsx";
import Footer from "../components/general/footer.jsx";

const Main = () => {
  return (
    <section className="main">
      <Hero />
      <AboutUs />
      <Formation />
      <Entreprise />
      <Footer border="main" />
    </section>
  );
};

export default Main;
